import UnderConstruction from '@/components/common/UnderConstruction'
import { createFileRoute } from '@tanstack/react-router'
import { LayoutDashboard } from 'lucide-react'

export const Route = createFileRoute('/_app/stock/')({
  staticData: {
    title: 'Tableau de bord',
    icon: LayoutDashboard,
    tab_icon: LayoutDashboard,
    permission: 'stock.dashboard.view',
    module: 'stock',
    section: 'Stock',
    order: 46,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  component: UnderConstruction,
})
